import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { CotaUsuarioAtiva } from "../interfaces/CotaUsuarioAtiva";

const firstDefined = (...values: any[]) =>
  values.find(
    (value) => value !== undefined && value !== null && String(value).trim() !== ""
  );

export const buscarCotasAtivasPessoaService = async (
  pessoaId: number
): Promise<CotaUsuarioAtiva[]> => {
  const Token = validateToken();

  if (!Token || !pessoaId) {
    return [];
  }

  const URL = `${Globais.DOMINIOBACK}/cota-usuario/pessoa/${pessoaId}/ativas`;

  try {
    const response = await axios.get(URL, {
      headers: { Authorization: Token.AuthStr },
    });

    const data = Array.isArray(response.data) ? response.data : [];

    return data.map((item: any) => {
      const numeroCota = firstDefined(
        item.numeroCota,
        item.CotaTable?.numeroCota,
        item.CotasUsuariosTable?.CotaTable?.numeroCota,
        item.cota?.numeroCota
      );

      const nomeEmpreendimento = firstDefined(
        item.nomeEmpreendimento,
        item.empreendimento,
        item.empreend,
        item.CotaTable?.AptoTable?.EmpreendimentoTable?.nome,
        item.CotaTable?.EmpreendimentoTable?.nome,
        item.CotasUsuariosTable?.CotaTable?.AptoTable?.EmpreendimentoTable?.nome,
        item.EmpreendimentoTable?.nome,
        item.cota?.AptoTable?.EmpreendimentoTable?.nome
      );

      const numeroApto = firstDefined(
        item.numeroApto,
        item.apto,
        item.CotaTable?.AptoTable?.nome,
        item.CotasUsuariosTable?.numeroApto
      );

      const bloco = firstDefined(item.bloco, item.CotasUsuariosTable?.bloco, "");

      return {
        id: item.id,
        numeroCota: numeroCota ?? "-",
        numeroApto: numeroApto ?? "-",
        bloco,
        nomeEmpreendimento: nomeEmpreendimento ?? "Empreendimento nao informado",
      };
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
